// extracted by mini-css-extract-plugin
export default {"contentView":"Layout_contentView__nLxrK"};